import { Chip, ChipProps } from '@razz-team/ui-web';
import { useTranslation } from 'react-i18next';
import { components } from '../../../openapi/openapi';
import { useMemo } from 'react';
import { isPayoutProcessing } from '../../../openapi/payout';

interface PayoutStateProps extends ChipProps {
  payout: components['schemas']['ApiPayoutPayout'];
}

function getStatusColor(status: string) {
  switch (status) {
    case 'CREATED':
      return 'tertiary';
    case 'STARTED':
      return 'info';
    case 'PAUSED':
      return 'warning';
    case 'COMPLETED':
      return 'success';
    case 'CANCELED':
      return 'error';
    default:
      return 'tertiary';
  }
}

export function PayoutState({ payout, sx, ...props }: PayoutStateProps) {
  const { t } = useTranslation('payout');

  const text = useMemo(() => {
    switch (payout.state) {
      case 'CREATED':
        return t('Draft');
      case 'COMPLETED':
        return t('Paid');
      case 'CANCELED':
        return t('Aborted');
      case 'PAUSED':
        return t('Paused');
      default:
        return t('Processing');
    }
  }, [t, payout.state]);

  const done = payout.paidTransfers;
  const total = payout.totalTransfers;

  const color = getStatusColor(payout.state);
  const prefix = isPayoutProcessing(payout) && done && total ? `${done}/${total} ` : '';

  return (
    <Chip
      label={`${prefix}${text}`}
      size="small"
      color={color}
      sx={{
        borderRadius: 1,
        fontSize: '12px',
        fontWeight: 500,
        height: 'unset',
        padding: '4px 8px',
        ...sx,
      }}
      {...props}
    />
  );
}
